import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { SEO } from "@/hooks/useSEO";
import { Check } from "lucide-react";

const AffiliationMerci = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Bienvenue à bord ! – Unotif"
        description="Votre inscription au programme d'affiliation Unotif est confirmée. Rejoignez notre groupe Facebook avant de partir."
        canonical="/programme-affiliation-merci"
        noindex
      />
      <Header />

      <main className="flex-1 flex items-center justify-center px-6 py-24 lg:py-32">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#DBEFF2] mb-8">
            <Check className="w-10 h-10 text-[#0c94a6]" strokeWidth={3} />
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#074155] mb-6">
            Bienvenue à bord !
          </h1>

          <p className="text-base sm:text-lg text-[#495456] leading-relaxed mb-10 max-w-xl mx-auto">
            Vous êtes sur le point de recevoir votre lien d'affiliation par email. Mais avant de partir :
          </p>

          <Button
            asChild
            size="lg"
            className="bg-primary hover:bg-[hsl(187,87%,32%)] text-primary-foreground shadow-lg hover:shadow-xl transition-all duration-300 text-base px-8 py-6"
          >
            <a
              href="https://www.facebook.com/groups/unotif"
              target="_blank"
              rel="noopener noreferrer"
            >
              Rejoignez notre groupe Facebook
            </a>
          </Button>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default AffiliationMerci;
